export default __webpack_public_path__ + "static/8-opacity-9ee6b8ac123ecb0bc2e04fdb184b2bcf.png";